import { Component, Input, OnInit, Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import moment from 'moment';
import { NgbActiveModal, NgbModal, NgbModalRef, NgbCalendar, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerConfig, NgbDatepickerI18n, NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap'
import { QuoteSelectProductsEditConfirmBidComponent } from 'src/app/shared/components/quote-select-products-edit-confirm-bid/quote-select-products-edit-confirm-bid.component';
import { QuoteSelectProductsComponent } from 'src/app/shared/components/quote-select-products/quote-select-products.component';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { NgClass, NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { TwoDigitDecimaNumberDirective, CopyDirective, AllowNegativeDecimalNumber } from '../two-digit-decima-number.directive';
import { I18nModule } from '@spartacus/core';
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
  }
}
@Component({
    selector: 'app-quote-select-products-edit-bid',
    templateUrl: './quote-select-products-edit-bid.component.html',
    styleUrls: ['./quote-select-products-edit-bid.component.scss'],
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    ],
    imports: [NgClass, NgIf, FormsModule, TwoDigitDecimaNumberDirective, CopyDirective, NgFor, ReactiveFormsModule, NgbInputDatepicker, AllowNegativeDecimalNumber, DecimalPipe, DatePipe, I18nModule]
})
export class QuoteSelectProductsEditBidComponent implements OnInit {
  QPstartDate: NgbDate = null;
  QPendDate: NgbDate = null;
  nextMonth: string;
  preMonth: string;
  selectMonth: string;
  selectYear: string;
  form: UntypedFormGroup;
  @Input() qpStartDt;
  @Input() qpEndDt;
  qpSD: any;
  qpED: any;
  finalQPFromoDateErr: boolean = false;
  finalQPToDateErr: boolean = false
  isFinalQPFromDateValid: boolean = false
  isFinalQPToDateValid: boolean = false
  isFinalQPToGreater: boolean = false
  convertedDate: any;
  hoveredDate: NgbDate | null = null;
  private modalRef: NgbModalRef;
  div1: boolean = true;
  activeTab = 'none';
  priceTab = 'none';
  COI: boolean = false;
  ITB: boolean = false;
  OpenNegotiation: boolean = true;
  @Input() code: any;
  @Input() price: number;
  @Input() price1: number;
  @Input() indexPrice: number;
  @Input() indexPrice1: number;
  @Input() tabName: any;
  @Input() index: any;
  @Input() indexValue: any;
  @Input() value: any;
  @Input() quantity: any;
  @Input() parameter = [];
  @Input() dischargePortshw: any;
  @Input() disabled: boolean;
  productInfo: any;
  Info: any;
  priceVal: any;
  materialFixedPrice1: any;
  materialFixedPrice2: any;
  materialIndexPrice1: any;
  materialIndexPrice2: any;
  materialIndex = 1;
  InitialValue: number;
  FinalValue: number;
  InitialActive: boolean;
  FinalActive: boolean;
  checkbox: any
  dupData: any;
  defaultPrice: any;
  isDisabled: boolean = false;
  isHidden3 = false;
  isHidden2 = false;
  FixedPriceEmpty: boolean = false;
  IndexPriceEmpty: boolean = false;
  defaultValue:any=null; 
  displayFixedQPSection =false;
  QPValuSelectedError: boolean = false;
   fixedPremiumPriceEmpty: boolean = false;
  floatingPremiumPriceEmpty: boolean = false;

  constructor(private config: NgbDatepickerConfig, public activeModal: NgbActiveModal, public customProductService: CustomProductsService,
    private Modal: NgbModal, public ActiveModal: NgbActiveModal, public ModalService: NgbModal, private modalService: NgbModal) {
    const current = new Date();
    config.minDate = {
      year: current.getFullYear(), month:
        current.getMonth() + 1, day: current.getDate()
    };
    config.outsideDays = 'hidden';
  }

  ngOnInit(): void {
    console.log(this.index);
    this.value = this.quantity
    this.materialFixedPrice1 = this.price;
    this.materialFixedPrice2 = this.price1;
    this.materialIndexPrice1 = this.indexPrice;
    this.materialIndexPrice2 = this.indexPrice1;
    this.productInfo = this.index[this.indexValue];
    
    this.index.forEach(element => {
      if (element.childList?.length > 0) {
        element.childList.forEach(children => {
          if(children.isFixedDisabled==undefined){
            children.isFixedDisabled = false;
          }
          if(children.isIndexDisabled==undefined){
            children.isIndexDisabled = false;
          }
          if (children.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
            children.price = children.relativePrice || '0'
          }
          if (children.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
            children.price = children.premiumDiscount.value || '0'
          }
        })
      }

    });
    this.Info = this.code;
    if (this.indexValue > 0) {
      this.InitialValue = this.indexValue;
      this.FinalValue = this.indexValue + 1;
      this.FinalActive = true;
      this.InitialActive = false;

    } else {
      this.InitialValue = 1;
      this.FinalValue = 2;
      this.InitialActive = true;
      this.FinalActive = false;
    }
    if (this.disabled) {
      this.isDisabled = this.disabled;
    } else {
      this.isDisabled = false;
    }
    
    this.activeTab = this.tabName ? this.tabName : 'none';
    this.priceTab = this.tabName ? this.tabName : 'none';
   
    this.form = new UntypedFormGroup({
      secondDateRange: new UntypedFormControl(),
      finalQPFromDate: new UntypedFormControl(this.productInfo.finalQPFromDate ? this.productInfo.finalQPFromDate : null),
      finalQPToDate: new UntypedFormControl(this.productInfo.finalQPToDate ? this.productInfo.finalQPToDate : null)
    });
    this.qpStartDt = this.index[this.indexValue].finalQPFromDate ? this.changeStartEndDate(this.index[this.indexValue].finalQPFromDate) : null;
    this.qpEndDt = this.index[this.indexValue].finalQPToDate ? this.changeStartEndDate(this.index[this.indexValue].finalQPToDate) : null;
    this.form.controls['finalQPFromDate'].setValue(this.qpStartDt);
    this.form.controls['finalQPToDate'].setValue(this.qpEndDt);
    console.log(this.qpStartDt, 'qpStartDt')
    console.log(this.qpEndDt, 'qpEndDt')
  }
  qpChangeAction(event:any,options){  
    this.QPValuSelectedError = false
    options.qp=[];    
    if(event.target.value === 'Fixed QP'){     
      this.displayFixedQPSection = true;
    }else{
      this.displayFixedQPSection = false;
    }
    options.qp.push({"description": event.target.value, "uniqueRowNumber":event.currentTarget.options[event.currentTarget.options.selectedIndex].id})
  }

  toolTipShow2() {
    this.isHidden2 = true;
    const hover = document.getElementById('differential_values2');
    if (hover) hover.style.display = 'block';
  }
  toolTipHide2() {
    this.isHidden2 = false;
    const hover = document.getElementById('differential_values2');
    if (hover) hover.style.display = 'none';
  }

  toolTipShow3(i) {
    this.isHidden3 = true;
    const hover = document.getElementById('differential_values3' + i);
    if (hover) hover.style.display = 'block';
  }
  toolTipHide3(i) {
    const hover = document.getElementById('differential_values3' + i);
    if (hover) hover.style.display = 'none';
  }
  changeStartEndDate(date) {
    var laycanDate = this.getDateinCorrectFormat(date);
    return laycanDate;
  }
  getDateinCorrectFormat(selectedDate) {
    var formattedDate = new Date(selectedDate).getDate() + '-' + (new Date(selectedDate).getMonth() + 1) + '-' + new Date(selectedDate).getFullYear();
    return formattedDate;
  }

  setTitle(value) {
    switch (value) {
      case "Select year": return this.selectYear;
      case "Select month": return this.selectMonth;
      case "Next month": return this.nextMonth;
      case "Previous month": return this.preMonth;
      default: return;
    }
  }
  toggle(data: any) {
    data.toggle();
    let element3 = document.getElementsByClassName("btn btn-link ngb-dp-arrow-btn");
    for (let i = 0; i < element3.length; i++) {
      let value = element3[i].getAttribute("title");
      console.log(value);
      element3[i].setAttribute("title", this.setTitle(value));
    }

    let element4 = document.getElementsByTagName("ngb-datepicker-navigation-select")[0].children;
    for (let i = 0; i < element4.length; i++) {
      let value = element4[i].getAttribute("title");
      element4[i].setAttribute("title", this.setTitle(value))
    }
  }
  checkPad(d) {
    return (d < 10) ? '0' + d.toString() : d.toString();
  }
  defaultDate() {
    let date = new Date();
    this.convertedDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  }
  qpFromDateSelection(selectedDate) {
    if (selectedDate == null) {
      this.QPstartDate = null;
      this.QPendDate = null;
    }
    else {
      this.isFinalQPFromDateValid = false;
      this.defaultDate();
      //  this.counterOfferError = false;
      //  this.counterOfferErrorValue = '';
      //  this.showDateError = false;
      this.QPstartDate = selectedDate;
      this.QPendDate = selectedDate
      this.convertedDate = selectedDate;
      this.convertedDate = selectedDate.year + '-' + this.checkPad(selectedDate.month) + '-' + this.checkPad(selectedDate.day);
      const dateTime = moment(this.convertedDate, + '00:00' + 'YYYY-MM-DD HH:mm');
      this.qpSD = dateTime.format();
      this.index[this.indexValue].UnsavedQPFromValue = this.qpSD;
      this.index[this.indexValue].finalQPFromDate = this.qpSD;
    }
  }
  qpToDateSelection(selectedDate) {
    if (selectedDate == null) {
      this.QPstartDate = null;
      this.QPendDate = null;
    }
    else {
      this.isFinalQPToGreater = false;
      this.isFinalQPToDateValid = false;
      this.defaultDate();
      //  this.counterOfferError = false;
      //  this.counterOfferErrorValue = '';
      //  this.showDateError = false;
      this.QPstartDate = selectedDate;
      this.QPendDate = selectedDate
      this.convertedDate = selectedDate;
      this.convertedDate = selectedDate.year + '-' + this.checkPad(selectedDate.month) + '-' + this.checkPad(selectedDate.day);
      const dateTime = moment(this.convertedDate, + '00:00' + 'YYYY-MM-DD HH:mm');
      this.qpED = dateTime.format();
      this.index[this.indexValue].UnsavedQPToValue = this.qpED;
      this.index[this.indexValue].finalQPToDate = this.qpED;
    }
  }
  checkPriceValidation($event) {
    // tslint:disable-next-line:prefer-const

  }
  changeTab(data): any {
    this.activeTab = data;
    if (this.activeTab === 'FIXED_PRICE') {
      this.priceTab = 'FIXED_PRICE'
    }
    else if (this.activeTab === 'INDEX_PRICE') {
      this.priceTab = 'INDEX_PRICE'
    }
  }
  close(): any {
    this.ActiveModal.close();
  }
  checkpriceEnteredorNot() {
    let priceTabSelected = this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions;
    if ((priceTabSelected != 'FIXED_PRICE') ) {
      if (this.index[this.indexValue].childList == undefined) {
        if(this.Info.commodityType == 'CC'){
          if (this.materialIndexPrice1 == 0 || this.materialIndexPrice1 == undefined || this.materialIndexPrice1 == '') {
            this.IndexPriceEmpty = true;
          }
          else {
            this.IndexPriceEmpty = false;
          }
          return this.IndexPriceEmpty
        }
        else if (this.Info.commodityType == 'IO') {
          this.IndexPriceEmpty = false;
          return this.IndexPriceEmpty
        }
        else if(this.Info.commodityType == 'CA'){
           if( priceTabSelected == 'FIXED_PREMIUM' ) {
              if (this.index[this.indexValue].premDiscount == 0 || this.index[this.indexValue].premDiscount == undefined || this.index[this.indexValue].premDiscount == '') {
                    this.fixedPremiumPriceEmpty = true;
                  }
                  else {
                    this.fixedPremiumPriceEmpty = false;
                  }
                  return this.fixedPremiumPriceEmpty
            }else  if( priceTabSelected != 'FLOATING_PREMIUM' ) {  
                  this.floatingPremiumPriceEmpty = false;                  
                  return this.floatingPremiumPriceEmpty
        
              }      
          }     
      }
      else {
        this.index[this.indexValue].childList.forEach(x => {
          if (x.premDiscount == 0 || x.premDiscount == undefined || x.premDiscount == '') {
            x.IndexPriceEmpty = true;
          }
          else {
            x.IndexPriceEmpty = false;
          }
        });
        if (this.index[this.indexValue].childList.filter(x => { return x.IndexPriceEmpty == true }).length > 0) {
          this.IndexPriceEmpty = true;
        }
        else {
          this.IndexPriceEmpty = false;
        }
        return this.IndexPriceEmpty;
      }
    }
    if (priceTabSelected == 'FIXED_PRICE' ) {
      if (this.index[this.indexValue].childList == undefined) {
        if(this.Info.commodityType == 'CC'){
          if (this.materialFixedPrice1 == 0 || this.materialFixedPrice1 == undefined || this.materialFixedPrice1 == '') {
            this.FixedPriceEmpty = true;
          }
          else {
            this.FixedPriceEmpty = false;
          }
          return this.FixedPriceEmpty
        }
        else if (this.Info.commodityType == 'IO'){
          if (this.index[this.indexValue].relPrice == 0 || this.index[this.indexValue].relPrice == undefined || this.index[this.indexValue].relPrice == '') {
            this.FixedPriceEmpty = true;
          }
          else {
            this.FixedPriceEmpty = false;
          }
          return this.FixedPriceEmpty
        }
       
      }
      else {
        this.index[this.indexValue].childList.forEach(x => {
          if (x.relPrice == 0 || x.relPrice == undefined || x.relPrice == '') {
            x.FixedPriceEmpty = true;
          }
          else {
            x.FixedPriceEmpty = false;
          }
        });
        if (this.index[this.indexValue].childList.filter(x => { return x.FixedPriceEmpty == true }).length > 0) {
          this.FixedPriceEmpty = true;
        }
        else {
          this.FixedPriceEmpty = false;
        }
        return this.FixedPriceEmpty;
      }
    }
  }

  
  // checkQPdateValidation(){
  //   let flag: boolean;
  //   //to check to and from date required
  //   if( this.form.value.finalQPToDate == '' || this.form.value.finalQPToDate == null){
  //     this.isFinalQPToDateValid = true;
  //     //flag = this.isFinalQPToDateValid;
  //   }
  //   if(this.form.value.finalQPFromDate == '' || this.form.value.finalQPFromDate ==null){
  //     this.isFinalQPFromDateValid = true;
  //    // flag = this.isFinalQPToDateValid;
  //   }
  //   // to check to date is grater than from date
  //   if(!this.isFinalQPToDateValid && !this.isFinalQPFromDateValid){
  //     if(this.form.value.finalQPToDate<this.form.value.finalQPFromDate){
  //       this.isFinalQPToGreater=true;
  //       this.form.value.finalQPToDate = '';
  //     }else{
  //       this.isFinalQPToGreater=false;
  //     }
  //   }
  //   flag = this.isFinalQPToGreater || this.isFinalQPFromDateValid || this.isFinalQPToDateValid;

  //   return  flag;
  // }
  checkifQPisselected(){
    let isOneQPSelected = false;
    if(this.productInfo.isQPMultipleChoicesSelected==true){
     if(this.productInfo.pricingOptionsEnum[0].qp){
      if(this.defaultValue=='' || this.defaultValue ==null){
        isOneQPSelected = false;
      }
      else{
        isOneQPSelected = true;
      }
     }
     else{
      isOneQPSelected = false;
     }
    }
    else{
      isOneQPSelected = true; 
    }
    return isOneQPSelected;
  
  }

  checkQPdateValidation(){
    let flag: boolean;
      //to check to and from date required
      if( this.form.value.finalQPToDate == '' || this.form.value.finalQPToDate == null){
        this.isFinalQPToDateValid = true;
        //flag = this.isFinalQPToDateValid;
      }
      if(this.form.value.finalQPFromDate == '' || this.form.value.finalQPFromDate ==null){
        this.isFinalQPFromDateValid = true;
      // flag = this.isFinalQPToDateValid;
      }
    // to check to date is grater than from date
      if(!this.isFinalQPToDateValid && !this.isFinalQPFromDateValid){
        let formattedFromDate = this.customProductService.convertDateIntoYYYYMMDDFormat(this.form.value.finalQPFromDate);
        let formattedToDate = this.customProductService.convertDateIntoYYYYMMDDFormat(this.form.value.finalQPToDate);
  
        if(moment(formattedToDate).isBefore(moment(formattedFromDate),'day')){
          this.isFinalQPToGreater=true;
          this.form.value.finalQPToDate = '';
        }else{
          this.isFinalQPToGreater=false;
        }
      }
      flag = this.isFinalQPToGreater || this.isFinalQPFromDateValid || this.isFinalQPToDateValid;

   
   
    return  flag;
  }

  Openmodal() {
    if (this.indexValue === this.index.length - 1) {
      let dateValidationCheck:boolean;
      if(this.index[this.indexValue].isQuotationPeriodUnrestricted  
        && (this.index[this.indexValue].finalQPToDate !== undefined && this.index[this.indexValue].finalQPToDate !== '' && this.index[this.indexValue].finalQPToDate !== null) 
        && (this.index[this.indexValue].finalQPFromDate !== undefined && this.index[this.indexValue].finalQPFromDate !== '' && this.index[this.indexValue].finalQPFromDate !== null)){
          if((this.index[this.indexValue].pricingOptionsEnum.length == 1 && (this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions!='FIXED_PRICE'))){
            dateValidationCheck = this.checkQPdateValidation();
          }else if(this.index[this.indexValue].pricingOptionsEnum.length>1 && this.priceTab != 'FIXED_PRICE'){
            dateValidationCheck = this.checkQPdateValidation();
          }else{
            dateValidationCheck = false;
          }
      }else{
        // dateValidationCheck = false;
        if(this.index[this.indexValue].pricingOptionsEnum[0].qp){    
          if(this.index[this.indexValue].pricingOptionsEnum[0].qp[0].description == 'Fixed QP' && (this.form.value.finalQPFromDate == undefined || this.form.value.finalQPToDate == undefined)){
            this.defaultValue = this.index[this.indexValue]?.pricingOptionsEnum[0]?.qp[0]?.description;
            console.log('de', this.defaultValue);            
            this.isFinalQPFromDateValid = true;
            this.isFinalQPToDateValid = true;
            this.displayFixedQPSection =true;
            dateValidationCheck = true;
          } else{     
            dateValidationCheck =false;
            this.displayFixedQPSection =false;
          }
        }else{
          dateValidationCheck = false;
        }
      }
      let proceedFurther: boolean = this.checkpriceEnteredorNot();
      let QPValuSelectedlocal = this.checkifQPisselected()
      if (!proceedFurther && !dateValidationCheck && QPValuSelectedlocal == true) {
        this.QPValuSelectedError = false;
        this.ActiveModal.close();
        const ModalRef = this.modalService.open(QuoteSelectProductsEditConfirmBidComponent, { centered: true, size: 'md' });
        ModalRef.componentInstance.multipleProduct = this.Info;
        ModalRef.componentInstance.parameter = this.index;
        ModalRef.componentInstance.indexValue = this.indexValue;
        ModalRef.componentInstance.dischargePortshw = this.dischargePortshw;
        if (this.index[this.indexValue]?.isQuotationPeriodUnrestricted == true) {
          this.index[this.indexValue].finalQPFromDate = this.qpSD ? this.qpSD : this.productInfo?.finalQPFromDate;
          this.index[this.indexValue].finalQPToDate = this.qpED ? this.qpED : this.productInfo?.finalQPToDate;
        }
        if (this.productInfo?.maximumQuantity && this.productInfo?.maximumQuantity) {
          this.index[this.indexValue].Quantity = this.value;
          ModalRef.componentInstance.quantity = this.value;
        }

        if (this.productInfo) {
          for (let data of this.index) {
            this.dupData = this.index.filter((x) => x.productCode == data.productCode && x.pricingOptionsEnum[0].pricingOptions == data.pricingOptionsEnum[0].pricingOptions)
           
            if (this.dupData.length > 1 && this.Info.commodityType == 'CC') {
              this.isDisabled = true;
              for (let duplicateData of this.dupData) {
                if (duplicateData.childList == undefined) {

                  if (data.productCode == duplicateData.productCode && data.pricingOptionsEnum[0].pricingOptions == duplicateData.pricingOptionsEnum[0].pricingOptions) {
                    if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
                      duplicateData.relativePrice.value = this.materialFixedPrice1;
                    } else if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
                      duplicateData.premiumDiscount.value = this.materialIndexPrice1;
                    }
                  }
                }
              }
            }
            if (data.productCode != this.index[this.indexValue].productCode || data.pricingOptionsEnum[0].pricingOptions != this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions && this.Info.commodityType == 'CC') {
              this.isDisabled = false;
              if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
                this.code.combinedTenders[this.indexValue].relativePrice.value = this.materialFixedPrice1;
                ModalRef.componentInstance.materialFixedPrice1 = this.code.combinedTenders[this.indexValue].relativePrice.value;
                // ModalRef.componentInstance.materialFixedPrice2=this.code.combinedTenders[this.indexValue].relPrice;
              }
              if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
                this.code.combinedTenders[this.indexValue].premiumDiscount.value = this.materialIndexPrice1;
                ModalRef.componentInstance.materialIndexPrice1 = this.code.combinedTenders[this.indexValue].premiumDiscount?.value;
                // ModalRef.componentInstance.materialIndexPrice2=this.code.combinedTenders[this.indexValue].premDiscount;
              }
            } else if (this.Info.commodityType == 'IO' || this.Info.commodityType == 'CC') {
              this.isDisabled = false;
              if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
                // this.code.combinedTenders[this.indexValue].relativePrice.value = this.materialFixedPrice1;
                ModalRef.componentInstance.materialFixedPrice1 = this.code.combinedTenders[this.indexValue].relativePrice.value;
                // ModalRef.componentInstance.materialFixedPrice2=this.code.combinedTenders[this.indexValue].relPrice;
              }
              if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
                this.code.combinedTenders[this.indexValue].premiumDiscount.value = this.materialIndexPrice1;
                ModalRef.componentInstance.materialIndexPrice1 = this.code.combinedTenders[this.indexValue].premiumDiscount?.value;
                // ModalRef.componentInstance.materialIndexPrice2=this.code.combinedTenders[this.indexValue].premDiscount;
              }
            }
            if (this.productInfo?.maximumQuantity && this.productInfo?.minimumQuantity) {
              this.index[this.indexValue].Quantity = this.value;
              ModalRef.componentInstance.quantity = this.index[this.indexValue].Quantity;
            }

          }
          // if(this.Info.commodityType=='IO'||this.Info.commodityType=='CC' ){
          //   this.isDisabled=false;
          //   if(this.productInfo.pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE'){
          //     this.code.combinedTenders[this.indexValue].relativePrice.value = this.materialFixedPrice1;
          //     ModalRef.componentInstance.materialFixedPrice1=this.code.combinedTenders[this.indexValue].relativePrice.value;
          //     // ModalRef.componentInstance.materialFixedPrice2=this.code.combinedTenders[this.indexValue].relPrice;
          //   }
          //   if(this.productInfo.pricingOptionsEnum[0].pricingOptions=='INDEX_PRICE'){
          //     this.code.combinedTenders[this.indexValue].premiumDiscount.value = this.materialIndexPrice1;
          //     ModalRef.componentInstance.materialIndexPrice1=this.code.combinedTenders[this.indexValue].premiumDiscount.value;
          //     // ModalRef.componentInstance.materialIndexPrice2=this.code.combinedTenders[this.indexValue].premDiscount;
          //   }
          // }
        }
      }else{
        if(QPValuSelectedlocal == false){
          this.QPValuSelectedError = true;
        }
        else{
          this.QPValuSelectedError = false;
        }
      }

    }
    else {
      let proceedFurther: boolean = this.checkpriceEnteredorNot();
      let QPValuSelectedlocal = this.checkifQPisselected();
      let dateValidationCheck:boolean;
      if(this.index[this.indexValue].isQuotationPeriodUnrestricted  
        && (this.index[this.indexValue].finalQPToDate !== undefined && this.index[this.indexValue].finalQPToDate !== '' && this.index[this.indexValue].finalQPToDate !== null) 
        && (this.index[this.indexValue].finalQPFromDate !== undefined && this.index[this.indexValue].finalQPFromDate !== '' && this.index[this.indexValue].finalQPFromDate !== null)){
                if((this.index[this.indexValue].pricingOptionsEnum.length == 1 && (this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions!='FIXED_PRICE'))){
            dateValidationCheck = this.checkQPdateValidation();
          }else if(this.index[this.indexValue].pricingOptionsEnum.length>1 && this.priceTab != 'FIXED_PRICE'){
            dateValidationCheck = this.checkQPdateValidation();
          }else{
            dateValidationCheck = false;
          }
      }else{
       // dateValidationCheck = false;

  if(this.index[this.indexValue].pricingOptionsEnum[0].qp){
    if(this.index[this.indexValue].pricingOptionsEnum[0].qp[0].description == 'Fixed QP' && (this.form.value.finalQPFromDate == undefined || this.form.value.finalQPToDate == undefined)){
      this.defaultValue = this.index[this.indexValue]?.pricingOptionsEnum[0]?.qp[0]?.description;               
       this.isFinalQPFromDateValid = true;
       this.isFinalQPToDateValid = true;
       this.displayFixedQPSection =true;
       dateValidationCheck = true;
     } else{        
       dateValidationCheck =false;
       this.displayFixedQPSection =false;
     }
   }else{
     dateValidationCheck = false;
   }

        
      }
      if (!proceedFurther && !dateValidationCheck && QPValuSelectedlocal==true) {
        this.QPValuSelectedError = false;
        console.log(this.code);
        if (this.productInfo?.maximumQuantity && this.productInfo?.minimumQuantity) {
          if (this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE' || this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE'|| this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions == 'FIXED_PREMIUM' || this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions == 'FLOATING_PREMIUM') {
            this.index[this.indexValue].Quantity = this.value;        
          }
        }
        if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
          this.code.combinedTenders[this.indexValue].relativePrice.value = this.materialFixedPrice1;
          // this.code.combinedTenders[this.indexValue].relPrice = this.materialFixedPrice2;
          this.code.combinedTenders[this.indexValue].relative = this.materialFixedPrice1;
        }

        if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
          this.code.combinedTenders[this.indexValue].premiumDiscount.value = this.materialIndexPrice1;
          // this.code.combinedTenders[this.indexValue].premDiscount =this.materialIndexPrice2;
          this.code.combinedTenders[this.indexValue].premium = this.materialIndexPrice1;
          if (this.index[this.indexValue]?.isQuotationPeriodUnrestricted == true) {
            this.index[this.indexValue].finalQPFromDate=this.index[this.indexValue].UnsavedQPFromValue? this.index[this.indexValue].UnsavedQPFromValue:this.index[this.indexValue]?.finalQPFromDate;
            this.index[this.indexValue].finalQPToDate=this.index[this.indexValue].UnsavedQPToValue?this.index[this.indexValue].UnsavedQPToValue:this.index[this.indexValue]?.finalQPToDate;
        }
        }
        let previousIndexValues = []//this.index[this.indexValue];
        for(let x=0;x<=this.indexValue;x++){
         previousIndexValues = previousIndexValues.concat(this.index[x]);
        }
        let previousIndexChildValues = []//this.index[this.indexValue];
        for(let x=0;x<=this.indexValue;x++){
          previousIndexChildValues = previousIndexChildValues.concat(this.index[x].childList);
        }
        this.indexValue = this.indexValue + 1;
        this.defaultValue =null;
        this.displayFixedQPSection = false;
        let currentIndexChildValues = this.index[this.indexValue];
        this.index[this.indexValue].childList?.forEach(child => {
          if (child.isFixedDisabled == undefined) {
            child.isFixedDisabled = false;
          }
          if(child.isIndexDisabled == undefined){
            child.isIndexDisabled = false;
          }
        });
        let currentIndexValues = this.index[this.indexValue];
        if (this.index[this.indexValue]?.isQuotationPeriodUnrestricted == true) {
          this.qpStartDt = this.index[this.indexValue].finalQPFromDate ? this.changeStartEndDate(this.index[this.indexValue].finalQPFromDate) : null;
          this.qpEndDt = this.index[this.indexValue].finalQPToDate ? this.changeStartEndDate(this.index[this.indexValue].finalQPToDate) : null;
          this.qpSD=this.index[this.indexValue].finalQPFromDate?this.index[this.indexValue].finalQPFromDate:null;
          this.qpED=this.index[this.indexValue].finalQPToDate?this.index[this.indexValue].finalQPToDate:null;
         
          this.form.controls['finalQPFromDate'].setValue(this.qpStartDt);
          this.form.controls['finalQPToDate'].setValue(this.qpEndDt);
        }
        this.productInfo = this.code.combinedTenders[this.indexValue];
        if (this.Info.commodityType == 'IO') {
          this.isDisabled = false
          if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
            this.materialFixedPrice1 = this.code.combinedTenders[this.indexValue].relativePrice.value;
            // this.materialFixedPrice2=this.code.combinedTenders[this.indexValue].relPrice;
          }
          if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
            this.materialIndexPrice1 = this.code.combinedTenders[this.indexValue].premiumDiscount?.value;
            // this.materialIndexPrice2=this.code.combinedTenders[this.indexValue].premDiscount;
            if (this.index[this.indexValue]?.isQuotationPeriodUnrestricted == true) {
              this.index[this.indexValue].finalQPFromDate=this.index[this.indexValue].UnsavedQPFromValue? this.index[this.indexValue].UnsavedQPFromValue:this.index[this.indexValue]?.finalQPFromDate;
              this.index[this.indexValue].finalQPToDate=this.index[this.indexValue].UnsavedQPToValue?this.index[this.indexValue].UnsavedQPToValue:this.index[this.indexValue]?.finalQPToDate;
              }
          }
        }
        //for (let data of this.index) {

        let sameMaterials = []
        if (currentIndexValues) {
          if (previousIndexValues.length > 0) {
            sameMaterials = previousIndexValues.filter(curr => curr.productCode == currentIndexValues.productCode && curr.pricingOptionsEnum[0].pricingOptions == currentIndexValues.pricingOptionsEnum[0].pricingOptions);

            //sameMaterials = currentIndexValues.childList.filter(curr => previousIndexValues.some(pre => pre.productCode === curr.productCode && pre.pricingOptionsEnum[0].pricingOptions === curr.pricingOptionsEnum[0].pricingOptions));
            if (sameMaterials.length > 0) {
              sameMaterials.forEach(arr => {
                previousIndexValues.forEach(element => {
                  if (arr.productCode == element.productCode && arr.pricingOptionsEnum[0].pricingOptions === element.pricingOptionsEnum[0].pricingOptions) {
                    if (arr.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
                      this.materialFixedPrice1 = element.relativePrice.value;
                    }
                    else if (arr.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
                      this.materialIndexPrice1 = element.premiumDiscount.value
                    }
                    this.isDisabled = true
                  }
                  else {
                    if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
                      this.materialFixedPrice1 = this.code.combinedTenders[this.indexValue].relativePrice.value;
                    }
                    if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
                      this.materialIndexPrice1 = this.code.combinedTenders[this.indexValue].premiumDiscount?.value;
                      if (this.index[this.indexValue]?.isQuotationPeriodUnrestricted == true) {
                        this.index[this.indexValue].finalQPFromDate = this.qpSD ? this.qpSD : this.productInfo?.finalQPFromDate;
                        this.index[this.indexValue].finalQPToDate = this.qpED ? this.qpED : this.productInfo?.finalQPToDate;
                      }
                    }
                  }
                })
              })
            }
            else {
              this.isDisabled = false
              if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
                this.materialFixedPrice1 = this.code.combinedTenders[this.indexValue].relativePrice.value;
              }
              if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
                this.materialIndexPrice1 = this.code.combinedTenders[this.indexValue].premiumDiscount?.value;
                if (this.index[this.indexValue]?.isQuotationPeriodUnrestricted == true) {
                  this.index[this.indexValue].finalQPFromDate=this.index[this.indexValue].UnsavedQPFromValue? this.index[this.indexValue].UnsavedQPFromValue:this.index[this.indexValue]?.finalQPFromDate;
                  this.index[this.indexValue].finalQPToDate=this.index[this.indexValue].UnsavedQPToValue?this.index[this.indexValue].UnsavedQPToValue:this.index[this.indexValue]?.finalQPToDate;
                      }
              }

            }

          }
        }

        let sameChildList = [];
        if (currentIndexChildValues?.childList?.length > 0) {
          if (previousIndexChildValues?.length > 0) {
            sameChildList = currentIndexChildValues.childList.filter(curr => previousIndexChildValues.some(pre => pre.productCode === curr.productCode));
            if (sameChildList.length > 0) {
              sameChildList.forEach(arr => {
                previousIndexChildValues.forEach(element => {
                  if (arr.productCode == element.productCode) {
                    if (arr.pricingOptionsEnum.length == 1 && element.pricingOptionsEnum.length == 1) {
                      if (arr.pricingOptionsEnum[0]?.pricingOptions == 'INDEX_PRICE' && element.pricingOptionsEnum[0]?.pricingOptions == 'INDEX_PRICE') {
                        arr.isIndexDisabled = true;
                        arr.isFixedDisabled = false;
                        arr.premDiscount = element.premDiscount;
                      }
                      if (arr.pricingOptionsEnum[0]?.pricingOptions == 'FIXED_PRICE' && element.pricingOptionsEnum[0]?.pricingOptions == 'FIXED_PRICE') {
                        arr.isIndexDisabled = false;
                        arr.isFixedDisabled = true;
                        arr.relPrice = element.relPrice
                      }
                    }
                  }
                });
              })
            }
          }
        }
          // this.dupData = this.index.filter((obj) => obj.productCode == data.productCode && obj.pricingOptionsEnum[0].pricingOptions == data.pricingOptionsEnum[0].pricingOptions)
          // console.log(this.dupData, 'dupli')
          // if (this.dupData.length > 1 && this.Info.commodityType == 'CC') {
          //   for (let duplicateData of this.dupData) {
          //     if (duplicateData.childList == undefined) {

          //       if (data.productCode == duplicateData.productCode && data.pricingOptionsEnum[0].pricingOptions == duplicateData.pricingOptionsEnum[0].pricingOptions) {
          //         this.isDisabled = true;
          //         if (duplicateData.relative || duplicateData.premium) {
          //           if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
          //             this.materialFixedPrice1 = this.dupData[0].relative;
          //           }
          //           if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
          //             this.materialIndexPrice1 = this.dupData[0].premium;
          //           }
          //         }

          //       }
          //       if (duplicateData.productCode != this.index[this.indexValue].productCode || duplicateData.pricingOptionsEnum[0].pricingOptions != this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions && this.Info.commodityType == 'CC') {
          //         this.isDisabled = false
          //         if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
          //           this.materialFixedPrice1 = this.code.combinedTenders[this.indexValue].relativePrice.value;
          //         }
          //         if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
          //           this.materialIndexPrice1 = this.code.combinedTenders[this.indexValue].premiumDiscount.value;
          //           if (this.index[this.indexValue]?.isQuotationPeriodUnrestricted == true) {
          //             this.index[this.indexValue].finalQPFromDate = this.qpSD ? this.qpSD : this.productInfo?.finalQPFromDate;
          //             this.index[this.indexValue].finalQPToDate = this.qpED ? this.qpED : this.productInfo?.finalQPToDate;
          //           }
          //         }
          //       }
          //       console.log(this.index, 'index')
          //     }
          //   }
          // } else {
          //   this.isDisabled = false
          //   if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
          //     this.materialFixedPrice1 = this.code.combinedTenders[this.indexValue].relativePrice.value;
          //   }
          //   if (this.productInfo.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
          //     this.materialIndexPrice1 = this.code.combinedTenders[this.indexValue].premiumDiscount.value;
          //     if (this.index[this.indexValue]?.isQuotationPeriodUnrestricted == true) {
          //       this.index[this.indexValue].finalQPFromDate = this.qpSD ? this.qpSD : this.productInfo?.finalQPFromDate;
          //       this.index[this.indexValue].finalQPToDate = this.qpED ? this.qpED : this.productInfo?.finalQPToDate;
          //     }
          //   }
          // }


        //}
       
        if (this.index.length > 2 && this.indexValue != this.index.length - 1) {
          this.InitialValue = this.indexValue + 1;
          this.FinalValue = this.InitialValue + 1;
          this.InitialActive = true;
          this.FinalActive = false;
        }
        else {
          this.InitialActive = false;
          this.FinalActive = true;
        }
      } else{
        if(QPValuSelectedlocal == false){
          this.QPValuSelectedError = true;
        }
        else{
          this.QPValuSelectedError = false;
        }
      }
    }
       if (this.productInfo?.maximumQuantity && this.productInfo?.minimumQuantity) {
          this.quantity = this.index[this.indexValue].quantity;
          this.value = this.index[this.indexValue].quantity;
        }
  }
  backToPlacebid(): any {
    if (this.indexValue <= 0) {
      this.ActiveModal.close();
      const ModalRef = this.Modal.open(QuoteSelectProductsComponent, { centered: true, size: 'md' });
      ModalRef.componentInstance.productsInfo = this.Info;
      this.checkbox = this.code && this.code.combinedTenders;
      this.checkbox.map(val => {
        val.checked = true;
        ModalRef.componentInstance.parameter = this.index;
        console.log(this.index);
      })
      if (this.productInfo?.maximumQuantity && this.productInfo?.minimumQuantity) {
        this.quantity = this.productInfo.quantity
        this.index[this.indexValue].Quantity = this.value;
      }
    } else {
      if (this.indexValue == 1) {
        this.FinalValue = 2;
        this.InitialValue = 1;
        this.InitialActive = true;
        this.FinalActive = false;
      }
      else {
        this.FinalValue = this.FinalValue - 1;
        this.InitialValue = this.InitialValue - 1;
      }
      this.indexValue = this.indexValue - 1;
      this.isDisabled = false
      this.productInfo = this.code.combinedTenders[this.indexValue];
      console.log('this.index', this.index[this.indexValue]);
      if(this.index[this.indexValue]?.pricingOptionsEnum[0]?.qp){
        this.defaultValue = this.index[this.indexValue]?.pricingOptionsEnum[0]?.qp[0]?.description;
        if(this.defaultValue == 'Fixed QP'){
          this.displayFixedQPSection = true;
          this.qpStartDt = this.index[this.indexValue].finalQPFromDate ? this.changeStartEndDate(this.index[this.indexValue].finalQPFromDate) : null;
          this.qpEndDt = this.index[this.indexValue].finalQPToDate ? this.changeStartEndDate(this.index[this.indexValue].finalQPToDate) : null;
          this.form.controls['finalQPFromDate'].setValue(this.qpStartDt);
          this.form.controls['finalQPToDate'].setValue(this.qpEndDt);
        }else{
          this.displayFixedQPSection = false;
        }
      }
      
      if (this.index[this.indexValue]?.isQuotationPeriodUnrestricted == true) {
        // this.index[this.indexValue].finalQPFromDate = this.qpSD ? this.qpSD : this.index[this.indexValue]?.finalQPFromDate;
        // this.index[this.indexValue].finalQPToDate = this.qpED ? this.qpED : this.index[this.indexValue]?.finalQPToDate;
        this.qpStartDt = this.index[this.indexValue].finalQPFromDate ? this.changeStartEndDate(this.index[this.indexValue].finalQPFromDate) : null;
        this.qpEndDt = this.index[this.indexValue].finalQPToDate ? this.changeStartEndDate(this.index[this.indexValue].finalQPToDate) : null;
        this.form.controls['finalQPFromDate'].setValue(this.qpStartDt);
        this.form.controls['finalQPToDate'].setValue(this.qpEndDt);
      }
      this.priceTab = this.code.combinedTenders[this.indexValue].priceTab;
      this.dupData = this.code.combinedTenders.filter((x) => x.productCode == this.index[this.indexValue].productCode && x.pricingOptionsEnum[0].pricingOptions == this.index[this.indexValue].pricingOptionsEnum[0].pricingOptions)
      console.log(this.dupData, 'duplicates')
      for (let i = this.indexValue; i > 0; i--) {
        if (this.dupData.length > 1) {
          for (let duplicateData of this.dupData) {
            if (duplicateData.childList == undefined) {
              if (duplicateData.productCode == this.index[i - 1].productCode) {
                this.isDisabled = true;
                console.log("Last index:", i);
                console.log("Last duplicate item: ", this.index[i].productCode);
              }
            }
          }
        }
      }
      if (this.productInfo?.maximumQuantity && this.productInfo?.minimumQuantity) {
        this.quantity = this.index[this.indexValue].Quantity;
        this.value = this.index[this.indexValue].Quantity;
      }
      if (this.code.combinedTenders[this.indexValue].pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
        this.materialFixedPrice1 = this.code.combinedTenders[this.indexValue].relativePrice.value;
      }
      if (this.code.combinedTenders[this.indexValue].pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
        this.materialIndexPrice1 = this.code.combinedTenders[this.indexValue].premiumDiscount?.value;
      }
    }
  }
  changeQuantity(action,step){
    let currentValue;
    if(action == 'decrease'){
      currentValue = this.value - 5000;
      currentValue >= this.productInfo.minimumQuantity? this.value = currentValue: this.value;
      
    }else if(action == 'increase'){
      currentValue= this.value + 5000;
      currentValue <= this.productInfo.maximumQuantity? this.value = currentValue : this.value;
    }
  }
  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 46 || (k >= 48 && k <= 57));
  }
  Omit_Special_Char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 45 || k == 46 || (k >= 48 && k <= 57));
  }
  decimalFilter(event: any) {
    const reg = /^-?\d*(\.\d{0,4})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);

    if (!reg.test(input)) {
      event.preventDefault();
    }
  }
  formatQPDates(data) {
    return this.customProductService.formatQPDates(data);
  }
  getPricingBasisBasedOnOption(pricingOption, description) {
    return this.customProductService.getPricingBasisBasedOnOption(pricingOption, description)
  }
}